import { useSettings } from '@/hooks/useSettings'
import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

/**
 * Hook to get the Chinese font class based on user settings
 */
export function useChineseFont() {
  const { settings } = useSettings()
  const fontMap: Record<string, string> = {
    system: 'chinese-font-system',
    'lxgw-wenkai-tc': 'chinese-font-lxgw-wenkai-tc',
    'noto-sans-tc': 'chinese-font-noto-sans-tc',
    'noto-sans-sc': 'chinese-font-noto-sans-sc'
  }
  return fontMap[settings.chineseFont] || 'chinese-font-system'
}

/**
 * Component wrapper that applies Chinese font to its children
 */
export function ChineseText({
  children,
  className
}: {
  children: ReactNode
  className?: string
}) {
  const fontClass = useChineseFont()
  return <span className={cn(fontClass, className)}>{children}</span>
}
